<template>
	<div class="container">
		<div class="header">
			<div class="user-wrap">
				<img class="icon" :src="icoAvatar" />
				<div class="info">
					<div class="username">{{ userInfo.username }}</div>
					<div class="usertype">{{ userInfo.isSuper ? '超级管理员' : '普通管理员' }}</div>
				</div>
			</div>
		</div>
		
		<div class="user-link">
			<div class="item" data-link='member-list' @click="handlerClick">
				<img class="ico" src="~assets/images/icon-profile_member.png" />
				<div class="inf">待审陪诊人</div>
			</div>
			<div class="item" data-link='service-list' @click="handlerClick">
				<img class="ico" src="~assets/images/icon-profile_feedback.png" />
				<div class="inf">待处理投诉</div>
			</div>
			<div class="item" @click="handlerLogout">
				<img class="ico" src="~assets/images/icon-profile_logout.png" />
				<div class="inf">安全退出</div>
			</div>
		</div>
		
		<!-- 底部导航 -->
		<footer-bar :menu='arrMenu' :hov='1' />
	</div>
</template>

<script>
import {passportUserInfo, passportUserLogout} from '@/api/login'
	import FooterBar from 'components/FooterBar/FooterBar'
	export default{
		name: 'Profile',
		components: {
			FooterBar
		},
		data() {
			return {
				arrMenu: [],
				icoAvatar: require('assets/images/avatar.png'),
        userInfo: [],
			}
		},
		methods: {
			// 跳转
			handlerClick: function(e){
				let eLink = e.currentTarget.dataset.link
				console.log(eLink)
				this.$router.push({
					path: `/${eLink}`
				})
			},
			
			// 退出
			handlerLogout: function(){
				// 调用退出接口
        passportUserLogout().then(res => {
          this.$router.push({ path: '/login' })
          localStorage.removeItem('accessToken')
        })
        // ;
				// console.log('调用退出接口')
			}
		},
		mounted: function(){
			// 初始化底部导航
			this.arrMenu.push({ 
				name: '工作台', 
				icon: require('assets/images/nav/icon-nav1.png'), 
				icon_hov: require('assets/images/nav/icon-nav1_hov.png'), 
				link: 'home',
			})
			this.arrMenu.push({
				name: '我的', 
				icon: require('assets/images/nav/icon-nav2.png'), 
				icon_hov: require('assets/images/nav/icon-nav2_hov.png'), 
				link: 'profile',
			})
      passportUserInfo().then(res => {
        this.userInfo = res
        this.icoAvatar = res.avatar == '' || res.avatar == null ? this.icoAvatar : res.avatar
      })
		}
	}
</script>

<style scoped>
.header{ width: 100%; max-width: 7.5rem; height: 4.5rem; margin: 0 0 0.4rem; display: flex; flex-direction: column; justify-content: center; background-size: cover !important; background-position: 50% 50% !important; background: url('~assets/images/bg-profile.png');}
.user-wrap{ height: 1.2rem; padding: 0 0.3rem; display: flex; justify-content: flex-start; align-items: center;}
.user-wrap>.icon{ width: 1.2rem; height: 1.2rem; border-radius: 1.2rem;}
.user-wrap>.info{ color: #FFF; flex: 1; padding: 0 0 0 0.2rem;}
.user-wrap>.info>.username{ font-size: 0.36rem; line-height: 0.40rem; font-weight: 600;}
.user-wrap>.info>.usertype{ font-size: 0.26rem; line-height: 0.48rem;}

.user-link{ background: #FFF; background: #FFF; border-radius: 0.2rem; margin: 0 0.2rem; padding: 0 0.2rem;}
.user-link>.item{ height: 0.96rem; line-height: 0.96rem; position: relative; display: flex; justify-content: flex-start; align-items: center;}
.user-link>.item::after{ position: absolute; content: ''; left: 0; right: 0; bottom: 0; height: 1px; background: rgba(232, 232, 232, 0.8);}
.user-link>.item:before{ position: absolute; content: ""; width: 0.16rem; height: 0.16rem; border: 0.04rem solid rgba(102, 102, 102, 0.4); border-left: none; border-bottom: none; right: 0.16rem; top: 45%; transform: rotate(45deg) translateY(-45%);}
.user-link>.item>.ico{ width: 0.48rem; height: 0.48rem; margin: 0 0.1rem 0 0;}
.user-link>.item>.inf{ font-size: 0.28rem; color: #000;}
.user-link>.item:last-of-type::after{ display: none;}
</style>